/* eslint-disable import/prefer-default-export */
import { InfiniteData } from "@tanstack/react-query";
import { Article, GetArticlesQuery } from "@/graphql/gql/graphql";

export const parseInfiniteArticlesResponse = (
  data: InfiniteData<GetArticlesQuery>
) =>
  data.pages.reduce((acc: Article[], next) => {
    const recentList =
      next.getArticles?.articles?.map((articleInfo) => articleInfo?.entity) ||
      [];

    if (recentList) {
      return [
        ...acc,
        ...recentList.filter((articleInfo) => articleInfo),
      ] as Article[];
    }

    return acc;
  }, []);
